import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { listLocations, switchLocation } from '../../api/endpoints/locations';
import { useSession } from '../../auth/useSession';

const LOCATIONS_QUERY_KEY = ['business-locations'];

/** The owner's locations and the switch between them, shared by the sidebar and the Helios top bar. */
export function useLocations(enabled: boolean) {
  const { setActiveBusinessId } = useSession();
  const queryClient = useQueryClient();
  const locationsQuery = useQuery({ queryKey: LOCATIONS_QUERY_KEY, queryFn: listLocations, enabled });
  const switchMutation = useMutation({
    mutationFn: (businessId: string) => switchLocation(businessId),
    onSuccess: (result) => {
      setActiveBusinessId(result.businessId);
      // Every query is scoped to the active business, so a switch refreshes the whole cache.
      void queryClient.invalidateQueries();
    },
  });
  return { locations: locationsQuery.data?.data ?? [], switchMutation };
}
